export default __webpack_public_path__ + "static/media/picture_Pro_banner02.de84b394.png";